import React from 'react';
import { 
  Flex, 
  Heading, 
  Menu, 
  MenuButton, 
  MenuList, 
  MenuItem,
  MenuDivider,
  Icon,
  Text,
  Box,
} from '@chakra-ui/react';
import { AiOutlineLogout } from 'react-icons/ai'; 
import { useAuth } from '../../hooks/auth'; 
import { useNavigate } from 'react-router-dom'; 

const Header = () => {
  const { signOut, user } = useAuth(); 
  const navigate = useNavigate();
  const displayName = user?.name || user?.email || "Usuário";
  const userEmail = user?.email || "usuario@nogle.com";
  const userInitial = displayName.charAt(0).toUpperCase();

  return (
    <Flex
      as="header"
      h="20"
      alignItems="center"
      justifyContent="space-between"
      px={8}
      bg="surface"
      borderBottomWidth="1px"
      borderColor="gray.700"
    >
      <Heading 
        as="h1" 
        size="md" 
        color="white"
        cursor="pointer"
        onClick={() => navigate('/')}
      >
        Monitoramento Nogle
      </Heading>

      <Flex align="center" gap={4}>
        {user && (
          <Menu>
            <MenuButton
              as={Box}
              cursor="pointer"
              w="32px"
              h="32px"
              borderRadius="full"
              bg="secondary"
              display="grid" 
              placeItems="center" 
              _focus={{ 
                boxShadow: '0 0 0 2px var(--chakra-colors-secondary)', 
                border: 'none',
                outline: 'none'
              }}
            >
              <Text color="primary" fontWeight="bold" fontSize="md" lineHeight="1">
                {userInitial}
              </Text>
            </MenuButton>

            <MenuList 
              bg="surface" 
              borderColor="gray.700" 
              p={1} 
              zIndex={2000} 
            >
              <Box px={3} py={2} mb={2} borderBottom="1px solid" borderColor="gray.800">
                <Text fontWeight="bold" color="white">{displayName}</Text>
                <Text fontSize="xs" color="gray.500">{userEmail}</Text>
              </Box>
              <MenuDivider borderColor="gray.700" />
              <MenuItem 
                icon={<Icon as={AiOutlineLogout} w={4} h={4} />} 
                onClick={signOut}
                bg="transparent"
                color="red.400" 
                _hover={{ bg: 'gray.800', color: 'red.400' }}
              >
                Sair
              </MenuItem>
            </MenuList>
          </Menu>
        )}
      </Flex>
    </Flex>
  );
};

export default Header;